/**
 * @Author: abbeymart | Abi Akindele | @Created: 2020-09-25
 * @Company: Copyright 2020 Abi Akindele  | mConnect.biz
 * @License: All Rights Reserved | LICENSE.md
 * @Description: mc-central-ts: toolkit routes
 */

import type { RouteRecordRaw } from 'vue-router';

export const toolkitRoutes: Array<RouteRecordRaw> = [
  {
    path: '/toolkits',
    name: 'toolkits',
    redirect: '/toolkits/publications',
    component: () => import('pages/mc/McPage.vue'),
    meta: {
      title: 'Toolkits',
    },
    children: [
      {
        path: 'publications',
        name: 'publications',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Publications',
        },
      },
      {
        path: 'books',
        name: 'books',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Books',
        },
      },
      {
        path: 'templates',
        name: 'templates',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Templates',
        },
      },
    ],
  },
];
